import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { ImageWrapper, StyledButtonPlay } from 'components/Cards/Card/Card.css';
import { fontBold } from 'style/styled-components/cssGlobalVariables';
import { hexToRgba } from 'utils/fnColors';
import { MQ_NOT_TOUCH, MQ_TOUCH } from 'style/styled-components/cssMediaQueries';

export const animationType = 'ease-in-out';
export const animationDuration = '150ms';
export const animationDelay = '150ms';

export const Title = styled.p`
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 16px;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    float: left;
    font-family: ${fontBold};
    width: 100%;
    padding-top: 4px;
`;

export const MetaData = styled.p`
    color: ${(props) => hexToRgba(props.theme.brandedConfig.high_contrast, 0.7)};
    font-size: 12px;
    line-height: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    clear: both;
    width: 100%;
    opacity: 0;
    transition: opacity 300ms ${animationType} 0ms;

    ${MQ_TOUCH} {
        display: none;
    }
`;

export const CardPortraitWrapper = styled.div`
    --card-image-aspect-ratio: 2 / 3;
    --card-image-border: 2px solid transparent;

    ${StyledButtonPlay} {
        transition: opacity 300ms ${animationType} 0ms;
    }

    width: var(--card-width);
    height: var(--card-height);
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
    box-shadow: 0 4px 8px ${(props) => hexToRgba(props.theme.brandedConfig.black_color, 0.05)};
    transition: opacity ${animationDuration} ${animationType} ${animationDelay};

    &:focus-visible {
        outline: var(--focus-outline);
    }

    ${MQ_NOT_TOUCH} {
        &:hover {
            ${StyledButtonPlay} {
                transition: opacity 300ms ${animationType} 200ms;
                opacity: 1;
                pointer-events: all;
            }

            ${ImageWrapper} {
                outline: var(--focus-outline-solid);
                opacity: 1;
            }

            ${MetaData} {
                opacity: 1;
            }
        }
    }
`;
